/* unplugin-vue-components disabled */import { render } from "./QuizAnswersValidationAlert.vue?vue&type=template&id=dcdc9578&scoped=true&ts=true"
import script from "./QuizAnswersValidationAlert.vue?vue&type=script&lang=ts"
export * from "./QuizAnswersValidationAlert.vue?vue&type=script&lang=ts"

import "./QuizAnswersValidationAlert.vue?vue&type=style&index=0&id=dcdc9578&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcdc9578"]])

export default __exports__